import React, { useEffect, useState } from "react";
import "./App.css";
import "./layoutMediaQuery.css";
import "./resources/css/Sidebar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./components/Login";
import Home from "./components/home/Home";
import * as constants from "./constants/CONSTANT";
import PubSub from "pubsub-js";
import { Toast, ToastContainer } from "react-bootstrap";
import { PATHS } from "./constants/WebRouting";
import Auth from "./components/Auth/Auth";
import NoAccess from "./components/common/NoAccess";
import jwt_decode from "jwt-decode";
import UserProfieEdit from "./components/Backup/UserProfileEdit";
import { PaymentList, PaymentSlips } from "./components/Payment";
import { ExamList } from "./components/Exam";
import Result from "./components/result/result";
import { AssigmentList } from "./components/Assigment";
import { TimeTableList } from "./components/TimeTable";
import { StudentAttendanceList } from "./components/StudentAttendance";
// Website Components Starts Here
import DasboardHomeWebsite from "./components/website/Home";
import AboutPage from "./components/website/AboutPage";
import ClassTimeTable from "./components/TimeTable/ClassTimeTable";
import { ShowEvent } from "./components/Events";
import { Transport } from "./components/Transport";
import { Announcement } from "./components/announcement";
import Main from "./components/layout/Main";
import ForgetPassword from "./components/ForgetPassword";
import ResetPassword from "./components/ResetPassword";
//End Here Website Components

function App() {
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState("Confirmation");
  const [message, setMessage] = useState("");

  const [variant, setVariant] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [permissions, setPermissions] = useState();
  const mySubscriber = (msg, data) => {
    switch (msg) {
      case "RECORD_SAVED_TOAST":
        setTitle(data.title);
        setMessage(data.message);
        setModalShow(true);
        setVariant("success");
        break;
      case "RECORD_ERROR_TOAST":
        setTitle(data.title);
        setMessage(data.message);
        setModalShow(true);
        setVariant("danger");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    PubSub.subscribe("RECORD_SAVED_TOAST", mySubscriber);
    PubSub.subscribe("RECORD_ERROR_TOAST", mySubscriber);

    try {
      if (sessionStorage.getItem("token")) {
        let user = jwt_decode(sessionStorage.getItem("token"));
        console.log("useerr=>", user);
        setUserInfo(user);

        var perm = user.permissions
          ?.map(function (obj) {
            return obj.name;
          })
          .join(";");
        setPermissions(perm);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <React.Fragment key={Math.random()}>
      <ToastContainer className="p-3" position="top-center">
        <Toast
          show={modalShow}
          onClose={() => setModalShow(false)}
          delay={3000}
          bg={variant}
          className="text-white"
          autohide
        >
          {variant === "success" ? (
            <div
              className="p-1 m-1"
              style={{ backgroundColor: "#198754", color: "white" }}
            >
              <i className="fa-regular fa-circle-check text-white mx-2"></i>
              <strong className="me-auto">{title}</strong>
              <i
                className="fa-solid fa-xmark text-white float-right"
                style={{ float: "right" }}
                role="button"
                onClick={() => setModalShow(false)}
              ></i>
            </div>
          ) : (
            <div
              className="p-1 m-1"
              style={{ backgroundColor: "#DC3545", color: "white" }}
            >
              <i className="fa-regular fa-circle-check text-white mx-2"></i>
              <strong className="me-auto">{title}</strong>
              <i
                className="fa-solid fa-xmark text-white float-right"
                style={{ float: "right" }}
                role="button"
                onClick={() => setModalShow(false)}
              ></i>
            </div>
          )}

          <Toast.Body>
            {message instanceof Array ? (
              message.map((item) => {
                return <span>{item.msg}</span>;
              })
            ) : (
              <span>{message}</span>
            )}
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Router>
        <Routes>
          {/* Website Routes Starts Here */}
          <Route path="/" element={<Login />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/reset-password/:email" element={<ResetPassword />} />
          {/* <Route path="/contact-us" element={<Homepage />}></Route> */}
          <Route element={<Main />}>
            <Route path="/home" element={<Home />} />
            <Route path="/payments" element={<PaymentList />} />
            <Route path="/feeslips" element={<PaymentSlips />} />
            <Route path="/assigments" element={<AssigmentList />} />
            <Route path="/exams" element={<ExamList />} />
            <Route path="/results" element={<Result />} />
            <Route
              path="/studentattendances"
              element={<StudentAttendanceList />}
            />
            <Route path="/timetables" element={<ClassTimeTable />} />
            <Route path="/events" element={<ShowEvent />} />
            <Route path="/transport" element={<Transport />} />
            <Route path="/announcement" element={<Announcement />} />
            <Route path={"/myprofile"} element={<UserProfieEdit />} />
          </Route>
          {/* End Here Website Routes */}
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Auth
                allowedRoles={[constants.VIEW_CONTACT, constants.MODIFY_ALL]}
              />
            }
          ></Route>
          {/******** User Profile Edit *******/}
          {/* <Route element={<Auth allowedRoles={[]} />}> */}

          {/* </Route> */}
          <Route path="/no-access" element={<NoAccess />} />
        </Routes>
      </Router>
    </React.Fragment>
  );
}

export default App;
